let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2vr7B")).then(() => parcelRequire('2Zlgq'));